import React from "react";
import styled, { keyframes } from "styled-components";
import img1 from "../images/1.png";
import img2 from "../images/2.png";

const HeroSlider = () => {
  return (
    <Hero>
      <Slider>
        <Slide style={{ backgroundImage: `url(${img1})` }} delay="0s" />
        <Slide style={{ backgroundImage: `url(${img2})` }} delay="5s" />
      </Slider>
    </Hero>
  );
};

export default HeroSlider;

/* ---------------- STYLED COMPONENTS ---------------- */

const Hero = styled.section`
  position: relative;
  width: 100%;
  height: 70vh;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 50vh; /* smaller height on mobile */
  }
`;

const Slider = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

/* Keyframes same as your CSS */
const slideAnim = keyframes`
  0%   { opacity: 0; }
  10%  { opacity: 1; }
  45%  { opacity: 1; }
  55%  { opacity: 0; }
  100% { opacity: 0; }
`;

const Slide = styled.div`
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  opacity: 0;
  animation: ${slideAnim} 10s infinite;
  animation-delay: ${({ delay }) => delay};
`;
